/**
 * Envía un evento de conversión a Google Ads y ejecuta un callback al completarse.
 * @param {function} onComplete - La función a ejecutar después de enviar el evento.
 */
export const reportGtagConversion = (onComplete) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-17234583905/-hbTCInA294aEOHCi5pA",
      value: 1.0,
      currency: "MXN",
      // Aquí está la magia: gtag ejecutará tu función cuando termine.
      event_callback: onComplete,
    });
  } else {
    console.warn("gtag no está definido. La conversión no fue reportada.");
    // Incluso si gtag falla, ejecuta la acción para no romper la funcionalidad.
    if (typeof onComplete === "function") {
      onComplete();
    }
  }
};
